import { CopyIcon, ExternalLinkIcon } from 'lucide-react';

import { Alert, AlertAction, AlertDescription, AlertTitle } from '@nesso/ui/primitives/alert';
import { Button } from '@nesso/ui/primitives/button';

export function ClientBillingSheetSettings() {
    return (
        <section className="flex flex-col gap-4">
            <h3 className="text-lg font-bold">Payment method</h3>
            <Alert variant="warning" orientation="horizontal" className="gap-x-3">
                <AlertDescription className="flex-1 gap-1">
                    <AlertTitle className="col-start-1 text-base">No card on file</AlertTitle>
                    <Button
                        type="button"
                        variant="link"
                        size="sm"
                        className="-ml-2.5 text-warning-foreground"
                    >
                        Preview Client Form
                        <ExternalLinkIcon />
                    </Button>
                </AlertDescription>
                <AlertAction>
                    <Button type="button" className="has-[>svg]:px-4">
                        <CopyIcon />
                        Copy Request Link
                    </Button>
                </AlertAction>
            </Alert>
            <Button type="button" variant="link" size="sm" className="w-fit px-4">
                Enter Card Details
            </Button>
        </section>
    );
}
